var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app-details-layout"}},[_c('app-details-header'),_c('app-details-drawer'),_c('app-details-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }